import styled from 'styled-components';

export const PodcastContainer = styled.div`
  display: grid;
  margin-top: 3rem;
  grid-gap: 4rem 3rem;
  justify-content: space-between;
  align-items: space-between;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  margin-bottom: 5rem;
`;
